export type ResizeHandlePosition =
  | "top-left"
  | "top-right"
  | "bottom-left"
  | "bottom-right";

export const drawResizeHandle = (
  ctx: CanvasRenderingContext2D,
  corner: { x: number; y: number },
  length: number,
  width: number,
  position: ResizeHandlePosition
) => {
  ctx.save();
  ctx.strokeStyle = "#ff5476";
  ctx.lineWidth = width;
  ctx.lineCap = "round";
  ctx.lineJoin = "round"; // <- optional but helps!
  // ctx.globalCompositeOperation = "lighten";
  const radius = width; // or tweak this for bigger curve
  const bracketLength = length; // shorten straight parts a bit

  ctx.beginPath();

  switch (position) {
    case "top-left":
      ctx.moveTo(corner.x + bracketLength, corner.y);
      ctx.lineTo(corner.x + radius, corner.y);
      ctx.arcTo(corner.x, corner.y, corner.x, corner.y + radius, radius);
      ctx.lineTo(corner.x, corner.y + bracketLength);
      break;
    case "top-right":
      ctx.moveTo(corner.x - bracketLength, corner.y);
      ctx.lineTo(corner.x - radius, corner.y);
      ctx.arcTo(corner.x, corner.y, corner.x, corner.y + radius, radius);
      ctx.lineTo(corner.x, corner.y + bracketLength);
      break;
    case "bottom-left":
      ctx.moveTo(corner.x + bracketLength, corner.y);
      ctx.lineTo(corner.x + radius, corner.y);
      ctx.arcTo(corner.x, corner.y, corner.x, corner.y - radius, radius);
      ctx.lineTo(corner.x, corner.y - bracketLength);
      break;
    case "bottom-right":
      ctx.moveTo(corner.x - bracketLength, corner.y);
      ctx.lineTo(corner.x - radius, corner.y);
      ctx.arcTo(corner.x, corner.y, corner.x, corner.y - radius, radius);
      ctx.lineTo(corner.x, corner.y - bracketLength);
      break;
  }

  ctx.stroke();
  ctx.restore();
};
